import React, { useState, useRef, useEffect } from "react";
import "./styles/styles.css";

const IconWithTooltip = ({ children, tooltip, disabled }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [position, setPosition] = useState("top");
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (isHovered && wrapperRef.current) {
      let tableContainer = wrapperRef.current.closest(
        ".table-first-content, .table-second-content, .table-third-content",
      );

      if (tableContainer) {
        const containerRect = tableContainer.getBoundingClientRect();
        const elementRect = wrapperRef.current.getBoundingClientRect();
        const distanceFromTop = elementRect.top - containerRect.top;

        if (distanceFromTop < 80) {
          setPosition("bottom");
        } else {
          setPosition("top");
        }
      } else {
        const rect = wrapperRef.current.getBoundingClientRect();
        const tooltipHeight = 40;
        const spaceAbove = rect.top;
        const spaceBelow = window.innerHeight - rect.bottom;

        if (
          spaceAbove < tooltipHeight + 15 &&
          spaceBelow > tooltipHeight + 15
        ) {
          setPosition("bottom");
        } else {
          setPosition("top");
        }
      }
    }
  }, [isHovered]);

  return (
    <div
      ref={wrapperRef}
      className="icon-tooltip-wrapper"
      onMouseEnter={() => !disabled && setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {children}
      {tooltip && isHovered && !disabled && (
        <div className={`icon-tooltip icon-tooltip-${position}`}>{tooltip}</div>
      )}
    </div>
  );
};

export default IconWithTooltip;
